
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ServiceOutwardDialog extends _Ext.DialogBase<ServiceOutwardRow, any> {
        TaxRegistred: number;
        public ExchangeRate: number;

        protected getFormKey() { return ServiceOutwardForm.formKey; }
        protected getIdProperty() { return ServiceOutwardRow.idProperty; }
        protected getLocalTextPrefix() { return ServiceOutwardRow.localTextPrefix; }
        protected getNameProperty() { return ServiceOutwardRow.nameProperty; }
        protected getService() { return ServiceOutwardService.baseUrl; }
        protected getDeletePermission() { return ServiceOutwardRow.deletePermission; }
        protected getInsertPermission() { return ServiceOutwardRow.insertPermission; }
        protected getUpdatePermission() { return ServiceOutwardRow.updatePermission; }
        public form = new ServiceOutwardForm(this.idPrefix);

        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        constructor() {
            super();
            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 250;
            q.initDetailEditor(this, this.form.Details, Config);
            q.SetCategoryEightColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.CurrencyId);
            q.SetCategoryFullWidth(this.form.Details);
            q.SetCategoryEightColumn(this.form.VoucherTypeId);
            q.SetCategoryFourColumn(this.form.TaxAmount);
            q.SetCategoryFullWidth(this.form.Narration);
            q.setTextRightAlign(this.form.CurrencyId);
            q.setTextRightAlign(this.form.ExchangeRate);
            q.setTextRightAlign(this.form.TaxAmount);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.GrossAmount);
            //q.setTextRightAlign(this.form.KnockOffTotal);
            q.hideCategorylinks(this.element);
            q.hideEditorLabel(this.form.Details);

            q.hideEditorLabel(this.form.TaxDetails);
            q.hideEditorToolbar(this.form.TaxDetails);
            q.SetSix12Column(this.form.TaxDetails);
            //Remove toolbar of PartyBalance Grid
            q.hideEditorLabel(this.form.LedgerName);
            q.hideEditorCategoryLabel(this.form.TransDate.element);
            q.hideEditorCategoryLabel(this.form.CurrencyId.element);
            q.hideEditorCategoryLabel(this.form.TaxAmount.element);
            q.hideEditorCategoryLabel(this.form.VoucherTypeId.element);
            q.hideEditorCategoryLabel(this.form.Details.element);
            q.hideEditorCategoryLabel(this.form.TaxDetails.element);
            q.hideEditorCategoryLabel(this.form.Narration.element);
            this.form.LedgerId.changeSelect2(e => {

                var ledgerid = parseInt(this.form.LedgerId.value);
                //set Party Balance Grid based on Ledger Id
                if (ledgerid != null && ledgerid > 0) {
                    OMS.CustomerService.Retrieve({ EntityId: ledgerid }, response => {
                        this.form.LedgerName.value = response.Entity.LedgerName;

                        this.TaxRegistred = parseInt(response.Entity.TaxRegType);
                    }, { async: false })

                } let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.LedgerId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
            });
            (this.form.Details.view as any).onRowCountChanged.subscribe(() => {
                if (this.form.Details.getItems().length > 0) {
                    q.showAndDisableField(this.form.LedgerId);
                    //q.showAndDisableField(this.form.TaxId)
                }
                this.calculateTotals();
            });


            //this.form.TaxId.changeSelect2(e => {
            //    //Calculate Tax Values on the ServiceOutwards in the Detail Grid
            //    if (this.form.TaxId.value != "") {
            //        var taxrate = OMS.TaxRow.getLookup().itemById[this.form.TaxId.value].Rate;
            //        this.form.Rate.value = taxrate;
            //        var tdsamt = this.form.GrossAmount.value * (taxrate / 100);
            //        this.form.TdsTotal.value = tdsamt;
            //        this.form.TaxLedgerId.value = OMS.TaxRow.getLookup().itemById[this.form.TaxId.value].LedgerId;
            //    }
            //});

            //this.form.KnockOffTotal.addValidationRule(this.uniqueName, e => {
            //    //Validate that the knock off value is not less than or greater than total Amount
            //    if (this.form.KnockOffTotal.value != this.form.GrossAmount.value) {
            //        return "knock off values and total amount should match";
            //    }
            //});
            this.validateForm();
        }
        public calculateTotals() {
            var amt = 0;
            for (var k of this.form.Details.getItems()) {
                amt += k.Amount;
            }
            this.form.GrossAmount.value = amt;

            //if (this.form.TaxId.value != "") {
            //    var taxrate = OMS.TaxRow.getLookup().itemById[this.form.TaxId.value].Rate;
            //    var tdsamt = this.form.GrossAmount.value * (taxrate / 100);
            //    this.form.TdsTotal.value = tdsamt;

            //}
            this.CalculateAmountandTax();

        }
        // #region Total Weight, Amount and TAX Calculation
        public CalculateAmountandTax() {
            var Items = this.form.Details.getItems();
            if (!this.isViewMode()) {

                if (this.form.Details.getItems().length > 0) {

                    q.showAndDisableField(this.form.CurrencyId);
                    //q.showAndDisableField(this.form.ExchRate);
                    q.showAndDisableField(this.form.LedgerId);
                }
                else {
                    q.showAndEnableField(this.form.CurrencyId);
                    //q.showAndEnableField(this.form.ExchRate);
                    q.showAndEnableField(this.form.LedgerId);
                }

                if (parseInt(this.form.LedgerId.value) > 0) {

                    var HSN = [];
                    var Amount = [];
                    var TaxDetail = [];
                    var TaxDetail = [];
                    var ItemTotal = 0;
                    var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0; var tds = 0;
                    for (var x of Items) {

                        gramt += x.Amount || 0;

                        var temp = false;
                        for (let i = 0; i < HSN.length; i++) {
                            if (HSN[i] == x.TaxCode) {
                                Amount[i] += x.Amount || 0;
                                temp = true;
                            }
                        }

                        if (!temp) {
                            HSN.push(x.TaxCode);
                            Amount.push(x.Amount);
                        }
                        ItemTotal++;
                    };

                    this.form.NetAmount.value = gramt;
                    //this.form.Discount.value = disc;
                    var TaxAmount = 0;
                    var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == 19)[0].IsTaxApplicable;

                    if (TaxApplicable) {

                        var TaxItems = this.form.TaxDetails.getItems().length;
                        if (TaxItems > 0) {
                            this.form.TaxDetails.DeleteTax();
                        }



                        var partystate = this.form.State.value;
                        //OMS.CustomerService.Retrieve({
                        //    EntityId: parseInt(this.form.LedgerId.value)
                        //}, response => {
                        //    partystate = response.Entity.State
                        //}, { async: false });
                        var Cmpstate = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId].State;

                        //TODO: Get Company Country to Call appropriate TAX Helper
                        if (this.TaxRegistred != 290 && this.TaxRegistred != 288) {
                            if (partystate != Cmpstate) {
                                TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, false, this.TaxRegistred);
                                TaxDetail = TaxHelper.VoucherTaxCalculation(this.form.VoucherTypeId.value, gramt, this.form.TransDate.value, TaxDetail, false);
                            }
                            else {
                                TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, true, this.TaxRegistred);
                                TaxDetail = TaxHelper.VoucherTaxCalculation(this.form.VoucherTypeId.value, gramt, this.form.TransDate.value, TaxDetail, true);
                            }

                            var temp2 = this.form.TaxDetails.getData(TaxDetail);
                            this.form.TaxDetails.view.setItems(temp2, true);
                            var self = this;

                            TaxDetail.forEach(function (value: ServiceOutwardTaxRow) {
                                value.CCTaxAmount = value.TaxAmount * self.ExchangeRate;
                                if (value.TaxType != "TDS")
                                    TaxAmount += value.TaxAmount;
                                else
                                    tds += value.TaxAmount;
                            });
                        }

                        this.form.TaxAmount.value = TaxAmount;
                        this.form.GrossAmount.value = gramt + TaxAmount;
                    }
                    else {
                        this.form.GrossAmount.value = gramt;
                    }

                    //this.form.CCGrossAmount.value = this.form.GrossAmount.value * this.ExchangeRate;
                    //this.form.CCNetAmount.value = this.form.NetAmount.value * this.ExchangeRate;
                    //this.form.CCTaxAmount.value = this.form.TaxAmount.value * this.ExchangeRate;
                }
            }
        }

        // #endregion



        protected onDialogOpen() {
            super.onDialogOpen();
            var Tax = OMS.HSNTaxDetailsRow.getLookup().items.filter(x => x.Code == "JewelleryGST" && x.GroupId == 116 && x.IsInterState == true);
            if (this.form.LedgerId.value != "") {
                //set Party Balance Grid in Edit Mode
                let values;
            } else {
                var exchangerate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.ExchangeRate.value = exchangerate[0].ExchRate;
                this.ExchangeRate = this.form.ExchangeRate.value;
            }
            let AddressDetails: OMS.AddressMasterRow;
            OMS.AddressMasterService.GetAddress({
                LedgerId: parseInt(this.form.LedgerId.value)
            },
                response =>
                    AddressDetails = response.Entity,
                { async: false }
            );

            if (AddressDetails != null) {
                this.form.State.value = AddressDetails.StateName;
                this.form.Country.value = AddressDetails.CountryName;
                var city = AddressDetails.CityName;
                let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                    + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                this.form.Address1.value = address;

            }
        }


        protected onDialogClose() {
            closed = true;
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            var buttons = super.getToolbarButtons();

            var btnDelete = Q.first(buttons, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };
            //Report Generation Button
            buttons.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                reportKey: 'Finance.ServiceOutwardVoucher',
                getParams: () => ({
                    TransId: this.get_entityId()
                })
            }));

            return buttons;
        }

        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            //if (this.canDelete) {
            ServiceOutwardService.Delete(
                {

                    EntityId: this.entityId
                }, response => {
                    Serenity.SubDialogHelper.triggerDataChange(self);
                    self.dialogClose();
                    window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                });
        }
        //else {
        //        Q.alert("Further ServiceOutwards for the Vouchers have been made, Cannot delete");
        //        return;
        //    }
        //}
        validateBeforeSave() {
            super.validateBeforeSave();
            var isvalid = true;
            if (this.form.Details.getItems().length == 0) {
                q.alert('', 'Cannot save without any services', true, 2000);
                isvalid = false;
            } else {
                var items = this.form.Details.getItems();
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    if (item.Amount == 0 || item.Amount == null) {
                        q.alert('', 'Amount required for the services added! (' + (item.ServiceCode) + ')', true, 2000);
                        isvalid = false;
                    }
                }
            }
            return isvalid;
        }
    }
}
